<template>
	<div v-if="$parent.info != null" class="container-fluid sectionPadBottom">
		<div v-if="$parent.additional != null && $parent.additional != {}">
			<div
				v-for="(niceToMeet, index) in $parent.niceToMeets"
				:key="index"
				class="whiteContainer niceToMeet"
				:id="niceToMeet.name"
			>
				<div class="titleContainer">
					<h2
						class="title spacer"
						@click="$parent.toggleCollapseCard(index)"
					>
						<img
							:src="niceToMeet.icon"
							:id="'card-' + index"
							:alt="niceToMeet.title"
							style="margin-left: 10px; height: 35px; width: auto;"
						/>

						{{ niceToMeet.title }}
						<!-- <button @click="$parent.$parent.toggleCollapseCard(index)" v-if="$parent.isMobile" type="button" class="collapseArrow">
                            
                        </button> -->
						<span v-if="$parent.isMobile && $parent.activeCardIndex == index" class="arrow"></span>
						<span v-if="$parent.isMobile && $parent.activeCardIndex != index" class="arrow up"></span>
					</h2>
				</div>
				<div v-if="
								niceToMeet.name == 'nadlan' &&
								($parent.activeCardIndex == index || !$parent.isMobile )
							"
							class="indexesContainer nadlanContainer"
							style="gap: 10px;"
						>
							<div
								id='element#1' class="valueStat_flex"
							>
								<div
									class="mwa-indexes__stat-item mwa-indexes__stat-item--exchange"
								>
									<span
										class="valueStat_teal"
										v-if="
											$parent.additional.RealEstateIndices.hasOwnProperty(
												'SecondHand',
											) && $parent.additional.RealEstateIndices.SecondHand > 0
										"
										>{{ $parent.additional.RealEstateIndices.SecondHand }}</span
									>
									<span class="valueStat_teal" v-else> 0 </span>
									<img class="valueStat_img"
										src="/images/indexes/summary-exchange.svg"
										alt="עסקאות יד שניה"
									/>

									<div class="indexesFont">עסקאות יד שניה</div>
									
								</div>
								<div
									class="mwa-indexes__stat-item mwa-indexes__stat-item--new FirstHand"
								>
									<div class="mwa-indexes__stat-item-icon">
										<span
											class="valueStat_blue"
											v-if="
												$parent.additional.RealEstateIndices.hasOwnProperty(
													'FirstHand',
												) && $parent.additional.RealEstateIndices.FirstHand > 0
											"
											>{{ $parent.additional.RealEstateIndices.FirstHand }}</span
										>
										<span class="valueStat_blue" v-else> 0 </span>
										<img
											src="/images/indexes/summary-new.svg"
											alt="עסקאות יד ראשונה"
											class="valueStat_img"
										/>
									</div>
									<div class="indexesFont">עסקאות יד ראשונה</div>
								</div>
							</div>

							<div id="element#2" class="divider">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 30" height="70px">
								<line x1="1" y1="0" x2="1" y2="30" stroke="#05446C" stroke-width="0.1"></line>
								</svg>
							</div>
							

							<div
								id="element#3"
								class="indexesContainer--nadlan"
								style="text-align: center"
								v-if="($parent.activeCardIndex == index || !$parent.isMobile)
								&& niceToMeet.name == 'nadlan'"
							>
								<div
								class="mwa-cols__item"
								v-for="(item, index) in niceToMeet.nadlan_items"
								:key="index">

								<div class="mwa-cols__item-icon">
									<img :src="item.icon" />

									<button
										class="mwa-tooltip mwa-tooltip--icon tooltipstered"
										aria-haspopup="true"
										data-tooltip=""
										style="display: none"
									>
										Tooltip
									</button>
								</div>
								<div class="text-container">
									<div class="mwa-cols__item-title">
										<b v-if="item.title != 'שיוך מגזרי'" class="ng-binding">{{
											item.display
										}} </b>
										<b v-else class="ng-binding">{{ item.title }}</b>
									</div>
								
									<div>
										<b class="indexesFont">{{ item.indexesFonts }}</b>
									</div>

									<div
										v-if="item.table != null"
										class="mwa-cols__item-title"
										style="bottom: 1px"
									>
										<button
											v-if="item.display > 0"
											@click="
												$parent.toggleCollapse(item.selectedInfo, niceToMeet.name)
											"
											class="mwa-education__item-button"
											data-scroll-toggle="mwa-table-schools"
											aria-controls="mwa-education-body"
											aria-expanded="false"
										>
											<div>
												<span>
													<div class="more-info-arrow">

														<b class="indexesFont text-container">לפרטים נוספים</b>
														<img class="arrow-img"
														v-if="$parent.selectedInfo != item.selectedInfo"
														:src="item.arrow"
														alt=""
														style="bottom: 1px"
													/>
													<img class="arrow-img"
														v-else
														:src="item.arrowDown"
														alt=""
														style="bottom: 1px"
													/>
													</div>
													
												</span>
												
											</div>
										</button>
									</div>
								</div>
								</div>			
							</div>

						</div>
						
				<div
					:id="niceToMeet.name"
					v-if="
						($parent.activeCardIndex == index|| !$parent.isMobile)
					"
				>
					

					<div
						class="indexesContainer"
						style="text-align: center"
						v-if="$parent.activeCardIndex == index || !$parent.isMobile"
					>
						<div
							class="mwa-cols__item"
							v-for="(item, index) in niceToMeet.items"
							:key="index"
							@click="$parent.handleClick(item.link)"
							:style="{ cursor: item.link ? 'pointer' : 'default' }"
						>
							<div class="mwa-cols__item-icon">
								
								
								<div v-if="item.name == 'luxury'">
									<div class="gauge" >
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
										<circle cx="50" cy="50" r="45" stroke="#e0e0e0" stroke-width="4" fill="none" stroke-linecap="round" />
										<circle v-if="$parent.gaugeValue !== 0" 
												cx="50" cy="50" r="45" 
												:stroke="$parent.color" 
												stroke-width="6" 
												fill="none" 
												stroke-dasharray="282.74" 
												:stroke-dashoffset="$parent.dashoffset"
												stroke-linecap="round" 
												transform="rotate(-90 50 50)" />
										<line v-if="$parent.gaugeValue === 0" 
												x1="35" y1="50" x2="65" y2="50" 
												stroke="#e0e0e0" 
												stroke-width="4" 
												stroke-linecap="round" />
										<text v-if="$parent.gaugeValue !== 0" 
												x="50" y="50" 
												:fill="$parent.color" 
												font-family="rubik, arial" 
												font-size="38" 
												text-anchor="middle" 
												dominant-baseline="central" 
												font-weight="bold">{{ $parent.gaugeValue }}</text>
										</svg>
									</div>
								</div>

								<img v-else :src="item.icon" />
							</div>
							<div class="text-container">
								<div class="mwa-cols__item-title" v-if="String(item.display).trim() !== ''">
									<b v-if="item.title !== 'שיוך מגזרי'" class="ng-binding">
										{{ String(item.display).trim() !== '' ? item.display : '\u00A0' }}
									</b>
									<b v-else class="ng-binding">
										{{ item.title }}
									</b>
								</div>
								<div class="mwa-cols__item-title">
									<b v-if="item.title != 'שיוך מגזרי'" class="ng-binding">{{
										item.title
									}} </b>
									<b v-else class="ng-binding">{{ item.display }} </b>
								</div>
							
								<div>
									<b class="indexesFont">{{ item.indexesFonts }}</b>
								</div>

								<div
									v-if="item.table != null"
									class="mwa-cols__item-title"
									style="bottom: 1px"
								>
									<button
										v-if="item.display > 0"
										@click="
											$parent.toggleCollapse(item.selectedInfo, niceToMeet.name)
										"
										class="mwa-education__item-button"
										data-scroll-toggle="mwa-table-schools"
										aria-controls="mwa-education-body"
										aria-expanded="false"
									>
										<div>
											<span>
												<div class="more-info-arrow">

													<b class="indexesFont text-container">לפרטים נוספים</b>
													<img class="arrow-img"
													v-if="$parent.selectedInfo != item.selectedInfo"
													:src="item.arrow"
													alt=""
													style="bottom: 1px"
												/>
												<img class="arrow-img"
													v-else
													:src="item.arrowDown"
													alt=""
													style="bottom: 1px"
												/>
												</div>
												
											</span>
											
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>
					<transition
						v-for="(item, index) in niceToMeet.items.filter(
							(item) => item.table !== null,
						)"
						:key="index"
						mode="out-in"
						name="fade"
					>
						<div
							v-if="
								$parent.selectedInfo == item.selectedInfo && item.table.data
							"
							:id="item.selectedInfo + '_table'"
							class="whiteContainer whiteTableBox"
						>
							<div v-if="item.table.data" class="tableContainer">
								<div class="accordion">
									<div id="busTableAction" class="tableAction" v-if="niceToMeet.name == 'transport'">
										<div class="filtersBtnsContainer" >
											<div class="filterWrap"  style="width:100%;">
												<input class="btn big hollowClean filterBtn " 
												id="bus_station_search"
												style="width:100%;"
												type="text"
												v-model="searchBusStation"
												@input="searchBusStationFn"
												@focus="showSuggestions = true"
												@keydown.backspace="searchBusStationFn"
												placeholder="שם תחנה"
												/>
											</div>
											<div class="filterWrap"  style="width:100%;">
												<input class="btn big hollowClean filterBtn " 
												id="bus_Route_search"
												style="width:100%;"
												type="text"
												v-model="searchBusRoute"
												@input="searchBusRouteFn"
												@focus="showSuggestions = true"
												@keydown.backspace="searchBusRouteFn"
												placeholder="מספר קו"
												/>
											</div>
	
										</div>
										<div class="filtersBtnsContainer" >
											<div id="busStations_length" class="filterWrap"  style="width:100%;">
												<div style="display: flex; justify-content: left; align-items: left;">
													<b style="font-size: 14px;">{{ busStations.length }} תחנות</b>
												</div>
											</div>
										</div>
									</div>


	
									<table v-if="item.table.data" class="mainTable">
										<thead>
											<tr class="mainTable__row mainTable__row--header">
												<th
													v-for="(header, index) in item.table.headers"
													:key="index"
													class="mainTable__cell mainTable__cell--header"
													style="text-align: right"
												>
													{{ header }}
												</th>

												<th
													class="mainTable__cell mainTable__cell--header"
													style="text-align: right"
												></th>
											</tr>
										</thead>

										<tbody v-if="item.table.id != 'bus_lines_transition' && item.table.id != 'env_transition'">
											<tr
												v-for="(row, index) in itemsDisplay(item.table.data)"
												:key="index"
												class="mainTable__row"
												@click="$parent.zoomTo(row)"
											>
												<!-- no x and y fields... cell-->
												<td
													v-for="(cell, index1, num) in (({ x, y, ...rest }) =>
														rest)(row)"
													:data-head="item.table.headers[num]"
													:key="index1"
													class="mainTable__cell"
													style="text-align: right"
												>
													{{ cell }}
												</td>
												<!-- <td  data-head="כתובת" class="mainTable__cell" style="text-align: right"></td> -->
											</tr>
										</tbody>

										<tbody v-if="item.table.id == 'env_transition'">
											<tr
												v-for="(row, index) in itemsDisplay(item.table.data)"
												:key="index"
												class="mainTable__row"
												@click="$parent.zoomTo(row)"
											>
												<!-- no x and y fields... cell-->
												<td
													v-for="(cell, index1, num) in (({ x, y, ...rest }) => rest)(row)"
													:data-head="item.table.headers[num]"
													:key="index1"
													class="mainTable__cell"
													style="text-align: right"
												>
													<div v-if="item.table.headers[num] == 'קישור'">
														<a :href="cell" target="_blank" rel="noopener noreferrer">לקישור</a>
													</div>
													<div v-else>
														{{ cell }}
													</div>
												</td>
												<!-- <td  data-head="כתובת" class="mainTable__cell" style="text-align: right"></td> -->
											</tr>
										</tbody>

										<!-- "env_transition" -->


										<tbody v-if="item.table.id == 'bus_lines_transition'">
											<template v-for="(station, index) in busStationsDisplay">
												<tr :key="'1tr-' + index" class="mainTable__row">
													<td
														@click="$parent.zoomTo(station)"
														data-head="מספר סידורי"
														class="mainTable__cell"
														style="text-align: right"
													>
														{{ currentPage_stations * 10 - 10 + index + 1 }}
													</td>
													<td
														@click="$parent.zoomTo(station)"
														data-head="מספר תחנה"
														class="mainTable__cell"
														style="text-align: right"
													>
														{{ station.stop_code }}
													</td>
													<td
														@click="$parent.zoomTo(station)"
														data-head="שם תחנה"
														class="mainTable__cell"
														style="text-align: right"
													>
														{{ station.name }}
													</td>
													<td
														@click="$parent.zoomTo(station)"
														data-head="מיקום תחנה"
														class="mainTable__cell"
														style="text-align: right"
													>
														{{ station.address }}
													</td>
													<td
														@click="$parent.zoomTo(station)"
														data-head="הצג במפה"
														class="mainTable__cell"
														style="text-align: right"
													>
														<img
															src="images/transport/busStopIcon.png"
															alt="הצג במפה"
															style="height: 30px"
														/>
													</td>

													<td
														class="mainTable__cell arrowRow"
														@click="$parent.toggleCollapseRow(index)"
													>
														<button type="button" class="collapseArrow">
															<span v-if="$parent.selectedRow !== null &&
																$parent.selectedRow == index" class="arrow">
															</span>
															<span v-else class="arrow up"></span>
														</button>
													</td>
												</tr>

												<transition
													mode="out-in"
													name="fade"
													:key="'trans-' + index"
												>
													<tr
														v-if="
															$parent.selectedRow !== null &&
															$parent.selectedRow == index
														"
														:key="'2tr-' + index"
														class="mainTable__row mainTable__row--collapse"
													>
														<td colspan="9">
															<div class="collapsedRowContainerBus">
																<div
																	v-for="(
																		routes, agency
																	) in station.groupedRoutes"
																	:key="agency"
																	class="badge-container"
																>
																	<div
																		@click="$parent.zoomTo(station)"
																		class="agency-header"
																	>
																		<img
																			:src="$parent.getAgencyIconUrl(agency)"
																			class="badge-icon"
																			:alt="agency"
																		/>
																		<span
																			v-show="
																				$parent.getAgencyIconUrl(agency).endsWith(
																					'/bus.svg',
																				)
																			"
																			class="agency-name"
																			>{{ agency }}</span
																		>
																	</div>
																	<ul class="route-list">
																		<li
																			@click="$parent.showRouteLine(route)"
																			v-for="route in routes"
																			:key="route.route_short_name"
																		>
																			{{ route.route_short_name }}
																		</li>
																	</ul>
																</div>
															</div>
														</td>
													</tr>
												</transition>
											</template>
										</tbody>
									</table>

									<div class="tableSummary" v-if="item.table.id == 'bus_lines_transition'">
										<p class="plainText">נמצאו {{busStations.length }} תחנות אוטובוס</p>
										<ul class="pagination">
											<li v-show="currentPage_stations > 1">
												<button
													@click="prev_stations()"
													class="arrows backBtn"
													type="button"
												>
													<div class="arrowWrap">
														<span class="long"></span>
													</div>
													<span class="text">הקודם</span>
												</button>
											</li>
											<li class="paginate">
												{{ currentPage_stations }} / {{ totalPages_stations }}
											</li>
											<li>
												<button
													id="next"
													v-show="currentPage_stations < totalPages_stations"
													@click="next_stations()"
													class="arrows nextBtn"
													type="button"
													:disabled="currentPage_stations >= totalPages_stations"
												>
													<span class="text">הבא</span>
													<div class="arrowWrap"><span class="long"></span></div>
												</button>
											</li>
										</ul>
									</div>

									<div class="tableSummary" v-else>
										<p class="plainText">נמצאו {{item.table.data.length }} פרטים</p>
										<ul class="pagination">
											<li v-show="currentPage_rows > 1">
												<button
													@click="prev_rows()"
													class="arrows backBtn"
													type="button"
												>
													<div class="arrowWrap">
														<span class="long"></span>
													</div>
													<span class="text">הקודם</span>
												</button>
											</li>
											<li class="paginate">
												{{ currentPage_rows }} / {{ totalPages_rows(item.table.data) }}
											</li>
											<li>
												<button
													id="next"
													v-show="currentPage_rows < totalPages_rows(item.table.data)"
													@click="next_rows(item.table.data)"
													class="arrows nextBtn"
													type="button"
													:disabled="currentPage_rows >= totalPages_rows(item.table.data)"
												>
													<span class="text">הבא</span>
													<div class="arrowWrap"><span class="long"></span></div>
												</button>
											</li>
										</ul>
									</div>

								</div>
							</div>
						</div>
					</transition>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	const imagesToPreload = [
		"/images/indexes/indexes.svg",
		"/images/indexes/cols/home-price.svg",
		"/images/indexes/cols/avg-price.svg",
		"/images/indexes/cols/arenda-price.svg",
		"/images/indexes/cols/elite-price.svg",
		"/images/indexes/summary-5.svg",
		"/images/indexes/summary-4.svg",
		"/images/indexes/summary-3.svg",
		"/images/indexes/summary-avg.svg",
		"/images/education/education.svg",
		"/images/education/school.svg",
		"/images/education/arrow-orange.svg",
		"/images/education/arrow-orange-down.svg",
		"/images/education/kindergarten.svg",
		"/images/education/arrow-red.svg",
		"/images/education/arrow-red-down.svg",
		"/images/education/theatre.svg",
		"/images/education/arrow-blue.svg",
		"/images/education/arrow-blue-down.svg",
		"/images/education/man.svg",
		"/images/parks/parks.svg",
		"/images/parks/green-space.svg",
		"/images/parks/parks_and_gardens.svg",
		"/images/parks/distances.svg",
		"/images/services/services.svg",
		"/images/services/clinics.svg",
		"/images/services/arrow-green.svg",
		"/images/services/arrow-green-down.svg",
		"/images/services/public-institutes.svg",
		"/images/services/arrow-violet.svg",
		"/images/services/arrow-violet-down.svg",
		"/images/services/religious-institutes.svg",
		"/images/services/arrow-red.svg",
		"/images/services/arrow-red-down.svg",
		"/images/services/walking-distance.svg",
		"/images/transport/transport.svg",
		"/images/transport/bus.svg",
		"/images/transport/point.svg",
		"/images/transport/parking.svg",
		"/images/demography/demography.svg",
		"/images/demography/academic.svg",
		"/images/demography/children.svg",
		"/images/demography/chart.svg",
		"/images/demography/money.svg",
		"/images/demography/school.svg",
		"/images/environment/environment.svg",
		"/images/environment/status-green.svg",
		"/images/environment/radio.svg",
		"/images/environment/factory.svg"
	];


	export default {

		name: "niceToMeets",
		data() {
			return {
				suggestions : [],
				showSuggestions : false,
				searchBusStation: "",

				routes: [],
				showRouteSuggestion: false,
				searchBusRoute: "",

				currentPage_stations: 1,
				currentPage_rows: 1,

			};
			
		},
		beforeMount() {
			this.preloadImages();
		},
		computed: {
			busStationsDisplay() {
				return this.busStations.slice(
					(this.currentPage_stations - 1) * 10,
					this.currentPage_stations * 10
				);
			},
			totalPages_stations() {
				return Math.ceil(this.busStations.length / 10);
			},
			isMobile() {
				return window.innerWidth < 768;
			},	
			neighOrSetl() {
				return this.$store.state.neighborhoodId != null
					? "שכונה"
					: "יישוב";
			},
			busStations() {
				if (this.searchBusStation != "") {
					return this.suggestions;
				}
				if (this.searchBusRoute != "") {
					return this.busRoutes;
				}
				return this.$parent.additional.Transportation.BusStationsList;
			},
			busRoutes() {
				var accs = [];
				//nearByObjects.busStations
				this.$parent.additional.Transportation.BusStationsList.forEach((station) => {
					//station.groupedRoutes
					for (const value of Object.values(station.groupedRoutes)) {
						value.forEach((route) => {
							if (route.route_short_name == this.searchBusRoute) {
								if (!accs.includes(route)) {
									accs.push(station);
								}
							}
						});
					}


				});
				// set unique by id
				accs = accs.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
				return accs;
			},
			
		},
		
		methods: {
			preloadImages() {
				imagesToPreload.forEach(imagePath => {
					const img = new Image();
					img.src = imagePath;
				});
			},
			totalPages_rows(rows) {
				return Math.ceil(rows.length / 10);
			},
			itemsDisplay(rows){
				//(rows => item.table.data)
				return rows.slice(
					(this.currentPage_rows - 1) * 10,
					this.currentPage_rows * 10
				);
			},
			prev_stations(){
				if (this.currentPage_stations > 1) {
					this.currentPage_stations--;
				}
			},
			next_stations(){
				if (this.currentPage_stations < this.totalPages_stations) {
					this.currentPage_stations++;
				}
			},
			prev_rows(){
				if (this.currentPage_rows > 1) {
					this.currentPage_rows--;
				}
			},
			next_rows(rows){
				if (this.currentPage_rows < this.totalPages_rows(rows)) {
					this.currentPage_rows++;
				}
			},
			searchBusStationFn() {
				this.currentPage_stations = 1;
				this.suggestions = this.$parent.additional.Transportation.BusStationsList.filter((station) =>
					station.name.includes(this.searchBusStation)
				);
			},
			searchBusRouteFn() {
				// go to first page
				this.currentPage_stations = 1;
				this.routes = this.$parent.additional.Transportation.BusStationsList.filter((station) =>
					//route_list => route_list.route_short_name.includes(this.searchBusRoute)
					station.route_list.forEach((route) => {
						return route.route_short_name == this.searchBusRoute;
					})
				);
			},
		},
	};
</script>


<style scoped>

.spacer {
	text-align: center;
	display: flex;
}

.gauge svg {
	width: 80px;
	height: 80px;
}

@media screen and (max-width: 768px) {
	.gauge svg {
		height: 50px;
		width: 50px;
	}

	.spacer {
		text-align: center;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}



 
.gauge svg text {
	font-family: 'rubik', Arial, sans-serif;
}

.mwa-indexes__stat-item{
	margin-left: 15px;
	margin-right: 15px;
}


.mwa-cols__item-icon img{
	height: 70px;
}

.indexesContainer--nadlan {
	display: flex;
	width: 100%;
    align-items: center;
	justify-content: space-around;
	margin-bottom: 20px;
}

.valueStat_flex {
	display: flex;
	justify-content: space-evenly;
}

.nadlanContainer{
	height: fit-content;
	padding-top: 25px;
	display: flex;
    justify-content: center;
	/*transform: scale(0.8);*/
	flex-wrap: nowrap;
    margin: 0 auto;
	
   

}



.divider{
	width: 5px;
	display:flex;
	justify-content: center;
}


@media screen and (max-width: 1200px) {
	.valueStat_flex {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-evenly;
		transform: scale(0.8);
	}

	.nadlanContainer{
		align-content: center;
		align-items: center;
		flex-wrap: wrap;
		flex-direction: column;
		margin-bottom: 20px;
	}

	.divider{
		display: none;
	}
}

@media screen and (max-width: 768px) {

	.divider {
		display: none;
	}

	.indexesContainer--nadlan {
		display:block;
		width: 80%;
	}
	

	#busTableAction {
		justify-content: space-around;
	}

	#busStations_length {
		margin-top: 10px;
	}
	.mwa-cols__item {
        margin-top: 10px;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-start;
        width: 80%;
        column-gap: 30px;
        align-items: center;
	}
	.mwa-cols__item-icon img {
		height: 50px;
		width: 50px;
	}
	.text-container{
		display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        font-size: 1.3em;

	}
	.arrow-img{
		height: 0.8em;
	}
	.more-info-arrow{
		display: flex;
		align-items: baseline;
	}

	.valueStat_teal{
		font-size: 30px;
	}

	.valueStat_blue{
		font-size: 30px;
	}

	.valueStat_img{
		height: 30px;
	}
}




.bus_container {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 15px;
	width: 100%;
}

.badge-container {
	display: flex;
	border: 1px solid #ccc;
	border-radius: 8px;
	flex-direction: row;
	align-items: center;
	padding-top: 10px;
	padding-bottom: 10px;
	margin: 3px;
}

.agency-header {
	display: flex;
	align-items: center;
	margin-bottom: 5px;
	margin: 10px;
	flex-direction: column;
}

.badge-icon {
	width: fit-content;
	height: 30px;
	margin: 6px;
}

.agency-name {
	font-weight: bold;
	font-size: 0.8em;
}

.route-list {
	display: flex;
	flex-wrap: wrap;
	list-style: none;
	padding: 0;
	margin: 0;
	gap: 5px;
}

.route-list li {
	background-color: #f0f0f0;
	padding: 5px 10px;
	border-radius: 12px;
	white-space: nowrap;
}
</style>
